export default class SortRowsByGrouping {
  execute(rows) {
    const itemGrouping = new Map(); // map: item object to subitems objects
    const idMapping = new Map(); // map: item id to item object

    rows.forEach((item) => {
      idMapping.set(item.itemId, item);
      itemGrouping.set(item, new Set());
      item.hasSubitems = true;
    });

    rows.forEach((item) => {
      if (item.parentItemId) {
        itemGrouping.get(idMapping.get(item.parentItemId)).add(item);
        itemGrouping.delete(item);
        item.hasSubitems = false;
      }
    });

    const sortedRows = [];
    itemGrouping.forEach((subitems, item) => {
      item.parent = null;
      item.subitems = [...subitems];

      if (subitems.size === 0) {
        item.hasSubitems = false;
      } else {
        subitems.forEach((subitem) => {
          subitem.parent = item;
          subitem.subitems = [];
        });
      }

      sortedRows.push(...[item, ...subitems]);
    });

    return sortedRows;
  }
}
